import { useCallback, useEffect, useState } from 'react';

function readSession() {
  if (typeof window === 'undefined') {
    return { id: null, name: '', displayName: '', role: 'Individual', email: '' };
  }
  const id = localStorage.getItem('neuro_user_id') || null;
  const name = localStorage.getItem('neuro_user_name') || '';
  const displayName =
    localStorage.getItem('neuro_display_name') ||
    (name.includes('@') ? name.split('@')[0] : name) ||
    '';
  const role = localStorage.getItem('neuro_user_role') || 'Individual';
  return { id, name, displayName, role, email: name };
}

/**
 * Reads the authenticated session already seeded by the existing auth flow.
 * Does not introduce a new auth mechanism or call a new endpoint.
 */
export default function useSessionUser() {
  const [user, setUser] = useState(readSession);

  const sync = useCallback(() => setUser(readSession()), []);

  useEffect(() => {
    window.addEventListener('storage', sync);
    return () => window.removeEventListener('storage', sync);
  }, [sync]);

  const logout = useCallback(() => {
    const displayName = localStorage.getItem('neuro_display_name');
    localStorage.clear();
    if (displayName) {
      try {
        localStorage.setItem('neuro_display_name', displayName);
      } catch {
        /* ignore */
      }
    }
    window.location.href = '/';
  }, []);

  return { user, logout, isAuthenticated: Boolean(user.id) };
}
